// A transient panel's wrapper: holds for TRANSIENT_MS (paused while hovered or
// focused), fades out, then reports `onGone` so the owner stops rendering it.
// It never decides what the panel *means* — an offer toast wrapped in this
// still has its answer on the Diplomacy tab.
import type { ReactNode } from 'react';
import { type AutoDismissOptions, useAutoDismiss } from '../lib/useAutoDismiss.js';

export function AutoFade({
  onGone,
  children,
  className = '',
  ...options
}: AutoDismissOptions & {
  readonly onGone: () => void;
  readonly children: ReactNode;
  readonly className?: string;
}) {
  const { phase, fadeMs, hold } = useAutoDismiss(onGone, options);
  return (
    // The wrapper takes no pointer events itself; the card inside does, and
    // mouseenter/leave still reach us from it.
    <div
      className={`pointer-events-none flex w-full justify-center ${className}`}
      data-fade-phase={phase}
      style={{
        opacity: phase === 'fading' ? 0 : 1,
        transition: fadeMs > 0 ? `opacity ${fadeMs}ms ease-out` : undefined,
      }}
      {...hold}
    >
      {children}
    </div>
  );
}
